const activeTweens = new Map<string, number>();

export function easeOutCubic(t: number): number {
  return 1 - Math.pow(1 - t, 3);
}

export function tweenNumber(
  key: string,
  from: number,
  to: number,
  durationMs: number,
  onFrame: (value: number) => void
): void {
  const prev = activeTweens.get(key);
  if (prev != null) cancelAnimationFrame(prev);

  if (!Number.isFinite(from)) from = to;
  if (Math.abs(from - to) < 0.05) {
    onFrame(to);
    return;
  }

  const start = performance.now();
  function frame(now: number): void {
    const t = Math.min(1, (now - start) / durationMs);
    const v = from + (to - from) * easeOutCubic(t);
    onFrame(v);
    if (t < 1) {
      activeTweens.set(key, requestAnimationFrame(frame));
    } else {
      activeTweens.delete(key);
      onFrame(to);
    }
  }
  activeTweens.set(key, requestAnimationFrame(frame));
}

export function setBarWidthSmooth(bar: HTMLElement, percent: number): void {
  const w = Math.max(0, Math.min(100, percent));
  bar.style.width = `${w}%`;
}

export function valueAtTime(points: Array<{ t: number; v: number }>, t: number): number {
  if (points.length === 0) return 0;
  if (t <= points[0].t) return points[0].v;
  const last = points[points.length - 1];
  if (t >= last.t) return last.v;
  for (let i = 1; i < points.length; i++) {
    const p1 = points[i];
    if (t <= p1.t) {
      const p0 = points[i - 1];
      const f = (p1.t - p0.t) > 0 ? (t - p0.t) / (p1.t - p0.t) : 0;
      return p0.v + (p1.v - p0.v) * f;
    }
  }
  return last.v;
}

export function resampleTimeline(
  points: Array<{ t: number; v: number }>,
  slots: number
): Array<{ t: number; v: number }> {
  if (points.length === 0) return [];
  const tMin = points[0].t;
  const tMax = points[points.length - 1].t;
  const span = Math.max(tMax - tMin, 60_000);
  const out: Array<{ t: number; v: number }> = [];
  for (let i = 0; i < slots; i++) {
    const t = tMin + (span * i) / Math.max(slots - 1, 1);
    out.push({ t, v: valueAtTime(points, t) });
  }
  return out;
}
